export default "__VITE_ASSET__4b851e17__"